export default __webpack_public_path__ + "static/thank_you_tablet-0c67cb2e007caea0c421ea602e5c42d6.png";